import bNavbar from './navbar';
import bNavbarNav from './navbar-nav';
import bNavbarBrand from './navbar-brand';
import bNavbarToggle from './navbar-toggle';
import navPlugin from '../nav';
import collapsePlugin from '../collapse';
import dropdownPlugin from '../dropdown';
import { registerComponents, vueUse } from '../../utils';

/* eslint-disable no-var, no-undef, guard-for-in, object-shorthand */

var components = {
  bNavbar: bNavbar,
  bNavbarNav: bNavbarNav,
  bNavbarBrand: bNavbarBrand,
  bNavbarToggle: bNavbarToggle,
  bNavToggle: bNavbarToggle
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
    Vue.use(navPlugin);
    Vue.use(collapsePlugin);
    Vue.use(dropdownPlugin);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/navbar/index.js
// module id = 693
// module chunks = 0